(function () {
  // v7.1 (VanillaGoods): topic tile photos are a blend, mostly vanilla (TILE_MIX: 5 vanilla, 2 coffee, 1 tea,
  //   rotating weekly across topics); counts still include every commodity.
  // v7 (VanillaGoods): Vanilla / Coffee / Tea checkboxes above Topic (Typesense field 'commodity', ?commodity= in the
  //   address). Ticking one narrows Topic, Subcategory and Region to that commodity; non-vanilla cards show a
  //   Coffee/Tea chip. If the index has no commodity field the block hides itself and search works as before.
  // v6 (VanillaGoods): filters, search, sort and page live in the page address (shareable links, back
  //   button), and the quick-pick topic tiles filter in place.
  // v5 (VanillaGoods): works with old section markup too (adds .blog-search class, icon, Featured sort, Filters toggle)
  // v4 (VanillaGoods):
  // - "Find an article" autocomplete removed (top search bar covers it)
  // - multi-select topic checkboxes with disjunctive facet counts (other options stay visible)
  // - Subcategory dropdown (clean names, narrows to the ticked topics)
  // - Author + Word count filters removed; read-time buckets match real article lengths
  // - active-filter chips, "Showing 1–12 of N", Clear only when something is set,
  //   mobile "Filters" toggle, friendlier topic labels
  // v3: default view = pinned posts (display_order) then weekly shuffle (shuffle_rank)
  const CHECKBOX_FACETS = ['commodity', 'primary_topic'];
  const SELECT_FACETS = ['subcategory', 'region'];
  const FACET_FIELDS = CHECKBOX_FACETS.concat(SELECT_FACETS);
  const FEATURED_SORT = 'display_order:asc,published_at:desc';
  const SHUFFLE_SORT = 'display_order:asc,shuffle_rank:asc';
  const COMMODITIES = ['Vanilla', 'Coffee', 'Tea'];  // always shown, in this order (others only when they have posts)
  const COMMODITY_HEADING = 'Category';
  // Which commodity's newest photo each topic tile shows (rotates one place per week so every topic takes a turn)
  const TILE_MIX = ['Vanilla', 'Coffee', 'Vanilla', 'Tea', 'Vanilla', 'Vanilla', 'Coffee', 'Vanilla'];

  // Display names only — the stored values stay unchanged.
  const TOPIC_LABELS = {
    'Vanilla Best For Guide': 'Best-For Guides',
    'Vanilla Comparison Guide': 'Comparisons',
    'Vanilla FAQ': 'FAQ',
    'Vanilla Origins & History': 'Origins & History',
    'Sustainability Commitment': 'Sustainability',
    'Company News & Updates': 'Company News'
  };
  const READ_TIME_LABELS = {
    '<10': 'Under 10 min',
    '10-15': '10–15 min',
    '15-20': '15–20 min',
    '>=20': '20+ min'
  };

  function debounce(fn, delay) {
    let timer = null;
    return function debounced() {
      const args = arguments;
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  function displayTitle(value) {
    return String(value || '').split(' | ')[0];
  }

  function normalizePath(path) {
    if (!path) return '';
    const withSlash = path.startsWith('/') ? path : '/' + path;
    return withSlash.endsWith('/') ? withSlash.slice(0, -1) : withSlash;
  }

  function quoteFilterValue(value) {
    const escaped = String(value || '').replaceAll('`', '\\`').trim();
    return '`' + escaped + '`';
  }

  function slugToLabel(value) {
    return String(value || '')
      .replaceAll('_', ' ')
      .replaceAll('-', ' ')
      .replace(/\b\w/g, function (m) {
        return m.toUpperCase();
      });
  }

  // "Extraction — Aging & Storage | aging-and-storage" -> "Aging & Storage"
  function subcategoryLabel(value) {
    const s = String(value || '');
    return s.split(' — ').pop().split(' | ')[0].trim() || s;
  }

  function facetLabel(field, value) {
    if (field === 'commodity') return String(value || '');
    if (field === 'primary_topic') return TOPIC_LABELS[value] || value;
    if (field === 'subcategory') return subcategoryLabel(value);
    return slugToLabel(value);
  }

  function buildTypesenseSearchUrl(config) {
    const protocol = (config.protocol || 'https').trim();
    const host = (config.host || '').trim();
    const port = (config.port || '').trim();
    const path = normalizePath((config.path || '').trim());
    const collection = (config.collection || '').trim();
    if (!host || !collection) return '';
    const portSegment = port ? ':' + port : '';
    return (
      protocol + '://' + host + portSegment + path +
      '/collections/' + encodeURIComponent(collection) + '/documents/search'
    );
  }

  function parseFacetCounts(facetCounts) {
    const facetMap = {};
    if (!Array.isArray(facetCounts)) return facetMap;
    facetCounts.forEach(function (facetEntry) {
      const fieldName = facetEntry.field_name;
      if (!fieldName || !Array.isArray(facetEntry.counts)) return;
      facetMap[fieldName] = facetEntry.counts.map(function (item) {
        return { value: item.value, count: Number(item.count || 0) };
      });
    });
    return facetMap;
  }

  function getSelectedSet(root, field) {
    if (!root._blogSearchState.selectedFacets[field]) {
      root._blogSearchState.selectedFacets[field] = new Set();
    }
    return root._blogSearchState.selectedFacets[field];
  }

  function sortedEntries(field, facetValues, selected) {
    const merged = new Map();
    if (field === 'commodity') COMMODITIES.forEach(function (c) { merged.set(c, 0); });
    (facetValues || []).forEach(function (entry) {
      merged.set(String(entry.value), Number(entry.count || 0));
    });
    selected.forEach(function (value) {
      if (!merged.has(value)) merged.set(value, 0);
    });
    if (field === 'commodity') {
      const rank = function (v) {
        const i = COMMODITIES.indexOf(v);
        return i === -1 ? COMMODITIES.length : i;
      };
      return Array.from(merged.entries()).sort(function (a, b) {
        return rank(a[0]) - rank(b[0]) || (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0);
      });
    }
    return Array.from(merged.entries()).sort(function (a, b) {
      const la = facetLabel(field, a[0]).toLowerCase();
      const lb = facetLabel(field, b[0]).toLowerCase();
      return la < lb ? -1 : la > lb ? 1 : 0;
    });
  }

  function renderSelect(root, field, container, facetValues) {
    const selected = getSelectedSet(root, field);
    const current = selected.size > 0 ? Array.from(selected)[0] : '';
    const items = sortedEntries(field, facetValues, selected);
    const allLabel = field === 'region' ? 'All regions' : 'All subcategories';

    let html = '<select data-blog-facet-select data-field="' + escapeHtml(field) + '" class="blog-search__facet-select" aria-label="Filter by ' + escapeHtml(field) + '">';
    html += '<option value="">' + allLabel + '</option>';
    items.forEach(function (pair) {
      const value = pair[0];
      html +=
        '<option value="' + escapeHtml(value) + '"' + (value === current ? ' selected' : '') + '>' +
        escapeHtml(facetLabel(field, value)) + ' (' + pair[1] + ')' +
        '</option>';
    });
    html += '</select>';
    container.innerHTML = html;
  }

  function renderCheckboxes(root, field, container, facetValues) {
    const selected = getSelectedSet(root, field);
    const items = sortedEntries(field, facetValues, selected);
    if (items.length === 0) {
      container.innerHTML = '<p class="blog-search__facet-empty">No values</p>';
      return;
    }
    const html = items
      .map(function (pair, index) {
        const value = pair[0];
        const count = pair[1];
        const checked = selected.has(value) ? ' checked' : '';
        const id = 'facet-' + root.dataset.sectionId + '-' + field + '-' + index;
        return (
          '<div class="blog-search__facet-item">' +
          '<label for="' + id + '">' +
          '<input type="checkbox" data-blog-facet-input data-field="' + escapeHtml(field) +
          '" value="' + escapeHtml(value) + '"' + checked + ' id="' + id + '">' +
          '<span>' + escapeHtml(facetLabel(field, value)) + '</span>' +
          '</label>' +
          '<span class="blog-search__facet-count">' + escapeHtml(count) + '</span>' +
          '</div>'
        );
      })
      .join('');
    container.innerHTML = '<div class="blog-search__facet-items">' + html + '</div>';
  }

  function renderFacet(root, field, facetValues) {
    const container = root.querySelector('[data-blog-facet="' + field + '"]');
    if (!container) return;
    if (SELECT_FACETS.indexOf(field) !== -1) {
      renderSelect(root, field, container, facetValues);
    } else {
      renderCheckboxes(root, field, container, facetValues);
    }
  }

  // exclude: leave one field's own selection out (so its options keep their counts)
  function buildFilterBy(root, exclude) {
    const state = root._blogSearchState;
    const filters = [];

    FACET_FIELDS.forEach(function (field) {
      if (field === exclude) return;
      const selected = getSelectedSet(root, field);
      if (selected.size === 0) return;
      const values = Array.from(selected).map(quoteFilterValue);
      filters.push(field + ':=' + (values.length === 1 ? values[0] : '[' + values.join(',') + ']'));
    });

    const rt = state.readTimeFilter;
    if (rt) {
      if (rt.startsWith('<')) {
        filters.push('read_time_minutes:<' + rt.slice(1));
      } else if (rt.startsWith('>=')) {
        filters.push('read_time_minutes:>=' + rt.slice(2));
      } else if (rt.indexOf('-') !== -1) {
        const parts = rt.split('-');
        filters.push('read_time_minutes:[' + parts[0] + '..' + (Number(parts[1]) - 1) + ']');
      }
    }
    return filters.join(' && ');
  }

  function serializeQueryParams(params) {
    const urlParams = new URLSearchParams();
    Object.entries(params).forEach(function (entry) {
      const value = entry[1];
      if (value === undefined || value === null || value === '') return;
      urlParams.set(entry[0], String(value));
    });
    return urlParams.toString();
  }

  function setStatus(root, status) {
    const loadingEl = root.querySelector('[data-blog-loading]');
    const errorEl = root.querySelector('[data-blog-error]');
    const emptyEl = root.querySelector('[data-blog-empty]');
    if (loadingEl) loadingEl.hidden = status !== 'loading';
    if (errorEl) errorEl.hidden = status !== 'error';
    if (emptyEl) emptyEl.hidden = status !== 'empty';
  }

  /* My Kitchen heart: assets/vg-me.js handles the click and keeps it in step with the heart on the recipe page. */
  function vgHeart(id, title) {
    var m = String(id == null ? '' : id).match(/(\d+)$/);
    if (!m) return '';
    var t = String(title || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    return '<button type="button" class="vg-save-icon" data-vg-save-recipe="' + m[1] + '" data-title="' + t + '" aria-pressed="false" aria-label="Save ' + t + '">' +
      '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg></button>';
  }
  function renderCards(root, hits) {
    const results = root.querySelector('[data-blog-results]');
    if (!results) return;

    results.innerHTML = (hits || [])
      .map(function (hitWrapper) {
        const doc = hitWrapper.document || {};
        const url = doc.url || '#';
        const title = displayTitle(doc.title || 'Untitled article');
        const summary = doc.summary || '';
        const imageUrl = doc.image_url || '';
        const imageAlt = doc.image_alt || title;

        const chips = [];
        if (doc.commodity && doc.commodity !== 'Vanilla') chips.push(doc.commodity);
        if (doc.primary_topic) chips.push(facetLabel('primary_topic', doc.primary_topic));
        if (doc.region) chips.push(slugToLabel(doc.region));
        if (doc.read_time_minutes) chips.push(String(doc.read_time_minutes) + ' min read');

        const imageHtml = imageUrl
          ? '<div class="blog-search__card-image-wrap"><img class="blog-search__card-image" src="' +
            escapeHtml(imageUrl) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy"></div>'
          : '';
        const chipHtml = chips.length
          ? '<div class="blog-search__card-meta">' +
            chips.map(function (chip) {
              return '<span class="blog-search__chip">' + escapeHtml(chip) + '</span>';
            }).join('') +
            '</div>'
          : '';

        return (
          '<article class="blog-search__card">' +
          '<a class="blog-search__card-link" href="' + escapeHtml(url) + '">' +
          imageHtml +
          '<div class="blog-search__card-body">' +
          '<h3 class="blog-search__card-title">' + escapeHtml(title) + '</h3>' +
          (summary ? '<p class="blog-search__card-summary">' + escapeHtml(summary) + '</p>' : '') +
          chipHtml +
          '</div>' +
          '</a>' + vgHeart(doc.id, title) +
          '</article>'
        );
      })
      .join('');
  }

  function renderMeta(root, payload) {
    const state = root._blogSearchState;
    const summaryEl = root.querySelector('[data-blog-summary]');
    const paginationEl = root.querySelector('[data-blog-pagination]');
    const pageLabelEl = root.querySelector('[data-blog-page-label]');
    const prevBtn = root.querySelector('[data-blog-prev]');
    const nextBtn = root.querySelector('[data-blog-next]');

    const found = Number(payload.found || 0);
    const perPage = Number(payload.request_params && payload.request_params.per_page) || state.perPage;
    const page = Number(payload.page || 1);
    const totalPages = Math.max(1, Math.ceil(found / perPage));

    if (summaryEl) {
      if (found === 0) {
        summaryEl.textContent = '0 articles';
      } else {
        const first = (page - 1) * perPage + 1;
        const last = Math.min(found, page * perPage);
        summaryEl.textContent =
          'Showing ' + first + '–' + last + ' of ' + found.toLocaleString() + ' article' + (found === 1 ? '' : 's');
      }
    }
    if (pageLabelEl) pageLabelEl.textContent = 'Page ' + page + ' of ' + totalPages;
    if (paginationEl) paginationEl.hidden = totalPages <= 1;
    if (prevBtn) prevBtn.disabled = page <= 1;
    if (nextBtn) nextBtn.disabled = page >= totalPages;

    state.page = page;
    state.totalPages = totalPages;
  }

  function hasActiveFilters(state) {
    if (state.query.trim()) return true;
    if (state.readTimeFilter) return true;
    return FACET_FIELDS.some(function (f) {
      return state.selectedFacets[f] && state.selectedFacets[f].size > 0;
    });
  }

  function renderActiveFilters(root) {
    const state = root._blogSearchState;
    const wrap = root.querySelector('[data-blog-active]');
    const clear = root.querySelector('[data-blog-clear]');
    const active = hasActiveFilters(state);
    if (clear) clear.hidden = !active;
    if (!wrap) return;

    const chips = [];
    FACET_FIELDS.forEach(function (field) {
      const selected = state.selectedFacets[field];
      if (!selected) return;
      selected.forEach(function (value) {
        chips.push(
          '<button type="button" class="blog-search__active-chip" data-remove-field="' + escapeHtml(field) +
          '" data-remove-value="' + escapeHtml(value) + '" aria-label="Remove filter ' +
          escapeHtml(facetLabel(field, value)) + '">' + escapeHtml(facetLabel(field, value)) +
          ' <span aria-hidden="true">&times;</span></button>'
        );
      });
    });
    if (state.readTimeFilter) {
      chips.push(
        '<button type="button" class="blog-search__active-chip" data-remove-field="read_time" data-remove-value="">' +
        escapeHtml(READ_TIME_LABELS[state.readTimeFilter] || state.readTimeFilter) +
        ' <span aria-hidden="true">&times;</span></button>'
      );
    }
    wrap.innerHTML = chips.join('');
    wrap.hidden = chips.length === 0;
  }

  // Featured + empty search box -> pinned posts, then this week's shuffled order.
  // Featured + typed search -> relevance. Any other sort option -> as selected.
  function effectiveSortBy(state, query) {
    if (state.sortBy === FEATURED_SORT) return query === '*' ? SHUFFLE_SORT : '';
    return state.sortBy || '';
  }

  async function fetchJson(url, key) {
    const response = await fetch(url, { headers: { 'X-TYPESENSE-API-KEY': key } });
    if (!response.ok) {
      const err = new Error('Typesense request failed with status ' + response.status);
      err.status = response.status;
      throw err;
    }
    return response.json();
  }

  // Index without a commodity field yet: drop the Vanilla/Coffee/Tea block instead of breaking search.
  function dropCommodityFacet(root) {
    const i = FACET_FIELDS.indexOf('commodity');
    if (i === -1) return false;
    FACET_FIELDS.splice(i, 1);
    delete root._blogSearchState.selectedFacets.commodity;
    const el = root.querySelector('[data-blog-facet="commodity"]');
    const block = el && (el.closest('.blog-search__facet') || el.parentElement);
    if (block) {
      block.hidden = true;
      block.style.display = 'none';
    }
    return true;
  }

  // Changing the commodity or topic: subcategory/region values may belong to the old selection.
  function clearDependents(state, field) {
    if (field === 'commodity' || field === 'primary_topic') state.selectedFacets.subcategory = new Set();
    if (field === 'commodity') state.selectedFacets.region = new Set();
  }

  async function runSearch(root) {
    const state = root._blogSearchState;
    const endpoint = buildTypesenseSearchUrl(state.config);
    if (!endpoint || !state.config.searchKey || !state.config.queryBy) return;

    setStatus(root, 'loading');
    renderActiveFilters(root);

    const query = state.query.trim() || '*';
    const params = {
      q: query,
      query_by: state.config.queryBy,
      filter_by: buildFilterBy(root),
      facet_by: FACET_FIELDS.join(','),
      max_facet_values: 100,
      per_page: state.perPage,
      page: state.page
    };
    const activeSort = effectiveSortBy(state, query);
    if (activeSort) params.sort_by = activeSort;

    // Disjunctive counts: for each group with a selection, count it without its own selection
    // so every option stays visible and more than one can be ticked.
    const extraFields = FACET_FIELDS.filter(function (f) {
      return getSelectedSet(root, f).size > 0;
    });
    const extraRequests = extraFields.map(function (field) {
      const p = {
        q: query,
        query_by: state.config.queryBy,
        filter_by: buildFilterBy(root, field),
        facet_by: field,
        max_facet_values: 100,
        per_page: 0
      };
      return fetchJson(endpoint + '?' + serializeQueryParams(p), state.config.searchKey);
    });

    try {
      const responses = await Promise.all(
        [fetchJson(endpoint + '?' + serializeQueryParams(params), state.config.searchKey)].concat(extraRequests)
      );
      const payload = responses[0];
      const facetMap = parseFacetCounts(payload.facet_counts);
      extraFields.forEach(function (field, i) {
        const own = parseFacetCounts(responses[i + 1].facet_counts);
        facetMap[field] = own[field] || [];
      });

      FACET_FIELDS.forEach(function (field) {
        renderFacet(root, field, facetMap[field] || []);
      });

      const hits = Array.isArray(payload.hits) ? payload.hits : [];
      renderCards(root, hits);
      renderMeta(root, payload);
      setStatus(root, hits.length === 0 ? 'empty' : 'ok');
      writeUrl(root);
    } catch (error) {
      if (error && error.status === 400 && dropCommodityFacet(root)) {
        runSearch(root);
        return;
      }
      setStatus(root, 'error');
      const errorEl = root.querySelector('[data-blog-error]');
      if (errorEl) errorEl.textContent = 'Search is unavailable right now. Please try again shortly.';
      console.error(error);
    }
  }

  // ------------------------------------------------------------ page address <-> state
  // ?q=vanilla&topic=Extract+%26+Craft&subcategory=...&region=Madagascar&read=<10&sort=published_at:desc&page=2
  const URL_FIELD = { commodity: 'commodity', topic: 'primary_topic', subcategory: 'subcategory', region: 'region' };
  function readUrl(root, href) {
    const state = root._blogSearchState;
    let u;
    try { u = new URL(href || window.location.href, window.location.origin); } catch (e) { return; }
    const p = u.searchParams;
    state.query = p.get('q') || '';
    state.selectedFacets = {};
    Object.keys(URL_FIELD).forEach(function (param) {
      const vals = p.getAll(param).filter(Boolean);
      if (!vals.length) return;
      const field = URL_FIELD[param];
      state.selectedFacets[field] = new Set(SELECT_FACETS.indexOf(field) !== -1 ? vals.slice(0, 1) : vals);
    });
    const rt = p.get('read') || '';
    state.readTimeFilter = READ_TIME_LABELS[rt] ? rt : '';
    const sort = p.get('sort');
    state.sortBy = sort === null ? FEATURED_SORT : sort;
    state.page = Math.max(1, parseInt(p.get('page'), 10) || 1);
  }
  function writeUrl(root) {
    const state = root._blogSearchState;
    const p = new URLSearchParams();
    if (state.query.trim()) p.set('q', state.query.trim());
    Object.keys(URL_FIELD).forEach(function (param) {
      const sel = state.selectedFacets[URL_FIELD[param]];
      if (sel) sel.forEach(function (v) { p.append(param, v); });
    });
    if (state.readTimeFilter) p.set('read', state.readTimeFilter);
    if (state.sortBy !== FEATURED_SORT) p.set('sort', state.sortBy);
    if (state.page > 1) p.set('page', state.page);
    const qs = p.toString();
    const url = window.location.pathname + (qs ? '?' + qs : '');
    if (url !== window.location.pathname + window.location.search) window.history.replaceState(null, '', url);
  }
  function syncControls(root) {
    const state = root._blogSearchState;
    const input = root.querySelector('[data-blog-search-input]');
    if (input) input.value = state.query;
    const sort = root.querySelector('[data-blog-sort]');
    if (sort) {
      sort.value = state.sortBy;
      if (sort.value !== state.sortBy) { sort.value = FEATURED_SORT; state.sortBy = FEATURED_SORT; }
    }
    const rt = root.querySelector('[data-blog-read-time-filter]');
    if (rt) rt.value = state.readTimeFilter;
  }

  // ------------------------------------------------------------ quick-pick topic tiles
  function tileFilter(href) {
    let u;
    try { u = new URL(href, window.location.origin); } catch (e) { return ''; }
    const parts = [];
    Object.keys(URL_FIELD).forEach(function (param) {
      const vals = u.searchParams.getAll(param).filter(Boolean);
      if (!vals.length) return;
      const q = vals.map(quoteFilterValue);
      parts.push(URL_FIELD[param] + ':=' + (q.length === 1 ? q[0] : '[' + q.join(',') + ']'));
    });
    return parts.join(' && ');
  }
  function setupTiles(root) {
    const state = root._blogSearchState;
    const wrap = root.querySelector('[data-vgbs-tiles]');
    if (!wrap) return;
    const tiles = Array.prototype.slice.call(wrap.querySelectorAll('.vgbs-tile'));
    if (!tiles.length) return;
    const c = state.config;
    const base = buildTypesenseSearchUrl(c).replace(/\/collections\/.*$/, '');
    // Two searches per tile: [0] all commodities (count + fallback photo), [1] the tile's mix commodity (photo).
    const week = Math.floor(Date.now() / 604800000);
    const searches = [];
    tiles.forEach(function (t, i) {
      const auto = t.hasAttribute('data-vgbs-tile-auto');
      const f = tileFilter(t.getAttribute('href'));
      const q = { collection: c.collection, q: '*', query_by: 'title', per_page: auto ? 1 : 0,
        include_fields: 'image_url', sort_by: 'published_at:desc' };
      if (f) q.filter_by = f;
      searches.push(q);
      const mix = TILE_MIX[(i + week) % TILE_MIX.length];
      const m = Object.assign({}, q, { per_page: auto ? 1 : 0,
        filter_by: (f ? f + ' && ' : '') + 'commodity:=' + quoteFilterValue(mix) });
      searches.push(m);
    });
    fetch(base + '/multi_search', { method: 'POST',
      headers: { 'X-TYPESENSE-API-KEY': c.searchKey, 'Content-Type': 'application/json' },
      body: JSON.stringify({ searches: searches }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        const results = p.results || [];
        tiles.forEach(function (t, i) {
          const res = results[2 * i];
          const pick = results[2 * i + 1];
          if (!res || res.error) return;
          const found = Number(res.found || 0);
          if (found === 0) { t.remove(); return; }
          const cnt = t.querySelector('[data-vgbs-count]');
          if (cnt) cnt.textContent = found + ' article' + (found === 1 ? '' : 's');
          const first = function (r) { return r && !r.error && r.hits && r.hits[0] && r.hits[0].document; };
          const pd = first(pick);
          const hit = pd && pd.image_url ? pd : first(res);
          const media = t.querySelector('.vgbs-tile__media');
          if (hit && hit.image_url && media && !media.querySelector('img')) {
            media.innerHTML = '<img class="vgbs-tile__img" src="' + escapeHtml(hit.image_url) +
              (hit.image_url.indexOf('?') < 0 ? '?width=320' : '&width=320') + '" alt="" loading="lazy" width="160" height="160">';
          }
        });
      })
      .catch(function () {});
    wrap.addEventListener('click', function (event) {
      const t = event.target.closest('.vgbs-tile');
      if (!t || event.metaKey || event.ctrlKey || event.shiftKey) return;
      let u;
      try { u = new URL(t.getAttribute('href'), window.location.origin); } catch (e) { return; }
      if (u.pathname !== window.location.pathname) return;
      event.preventDefault();
      readUrl(root, u.href);
      syncControls(root);
      tiles.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      runSearch(root);
      const res = root.querySelector('.blog-search__results-wrap');
      if (res) res.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function resetAndSearch(root) {
    root._blogSearchState.page = 1;
    runSearch(root);
  }

  function bindFacetChange(root) {
    root.addEventListener('change', function (event) {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (target.matches('[data-blog-facet-select]')) {
        const field = target.getAttribute('data-field');
        const value = target.value || '';
        root._blogSearchState.selectedFacets[field] = new Set(value ? [value] : []);
        resetAndSearch(root);
        return;
      }

      if (target.matches('[data-blog-facet-input]')) {
        const field = target.getAttribute('data-field');
        const value = target.getAttribute('value');
        if (!field || !value) return;
        const selected = getSelectedSet(root, field);
        if (target.checked) selected.add(value);
        else selected.delete(value);
        // a subcategory from a topic that is no longer ticked would hide everything
        clearDependents(root._blogSearchState, field);
        resetAndSearch(root);
      }
    });

    root.addEventListener('click', function (event) {
      const chip = event.target.closest('[data-remove-field]');
      if (!chip || !root.contains(chip)) return;
      const field = chip.getAttribute('data-remove-field');
      const value = chip.getAttribute('data-remove-value');
      const state = root._blogSearchState;
      if (field === 'read_time') {
        state.readTimeFilter = '';
        const rt = root.querySelector('[data-blog-read-time-filter]');
        if (rt) rt.value = '';
      } else if (state.selectedFacets[field]) {
        state.selectedFacets[field].delete(value);
        clearDependents(state, field);
      }
      resetAndSearch(root);
    });
  }

  // Works with older versions of the section markup: removes retired filters
  // (Author, Focus Keyword, Word count, "Find an article"), restyles Read time,
  // and swaps the big toolbar "Clear filters" button for the small "Clear all" link.
  // v5
  function upgradeLegacyMarkup(root) {
    // Old section markup used class "blog-search__root" — the stylesheet needs "blog-search"
    root.classList.add('blog-search');

    // Search bar icon
    const wrap = root.querySelector('.blog-search__search-wrap');
    if (wrap && !wrap.querySelector('.blog-search__search-icon')) {
      wrap.insertAdjacentHTML('afterbegin',
        '<svg class="blog-search__search-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg>');
    }
    const input = root.querySelector('[data-blog-search-input]');
    if (input) input.placeholder = 'Search articles, topics, origins or keywords';

    // Sort: visible label + "Featured" option (weekly shuffle)
    const sortEl = root.querySelector('[data-blog-sort]');
    if (sortEl) {
      if (!sortEl.querySelector('option[value="' + FEATURED_SORT + '"]')) {
        const o = document.createElement('option');
        o.value = FEATURED_SORT; o.textContent = 'Featured';
        sortEl.insertBefore(o, sortEl.firstChild);
      }
      const sw = sortEl.closest('.blog-search__sort-wrap');
      if (sw) {
        const vh = sw.querySelector('.visually-hidden');
        if (vh) { vh.className = 'blog-search__sort-label'; vh.textContent = 'Sort'; }
      }
    }

    // Mobile "Filters" toggle
    const toolbar = root.querySelector('.blog-search__toolbar');
    if (toolbar && !toolbar.querySelector('[data-blog-filters-toggle]')) {
      const t = document.createElement('button');
      t.type = 'button';
      t.className = 'blog-search__filters-toggle';
      t.setAttribute('data-blog-filters-toggle', '');
      t.setAttribute('aria-expanded', 'false');
      t.textContent = 'Filters';
      toolbar.appendChild(t);
    }

    ['author', 'focus_keyword'].forEach(function (field) {
      const el = root.querySelector('[data-blog-facet="' + field + '"]');
      if (el) {
        const block = el.closest('.blog-search__facet') || el.closest('details') || el.parentElement;
        if (block) block.remove();
      }
    });
    const wc = root.querySelector('[data-blog-word-count-filter]');
    if (wc) {
      const block = wc.closest('.blog-search__facet') || wc.parentElement;
      if (block) block.remove();
    }
    const jump = root.querySelector('.blog-search__titlejump');
    if (jump) jump.remove();

    // Subcategory: old markup used a <details> checkbox block — make it a plain titled block
    const sub = root.querySelector('[data-blog-facet="subcategory"]');
    if (sub) {
      const det = sub.closest('details');
      if (det) {
        const div = document.createElement('div');
        div.className = 'blog-search__facet blog-search__facet--select';
        div.innerHTML = '<p class="blog-search__facet-title">Subcategory</p>';
        div.appendChild(sub);
        det.replaceWith(div);
      }
    }
    const reg = root.querySelector('[data-blog-facet="region"]');
    if (reg) {
      const det = reg.closest('details');
      if (det) {
        const div = document.createElement('div');
        div.className = 'blog-search__facet blog-search__facet--select';
        div.innerHTML = '<p class="blog-search__facet-title">Origin / region</p>';
        div.appendChild(reg);
        det.replaceWith(div);
      }
    }
    const topicSummary = root.querySelector('[data-blog-facet="primary_topic"]');
    if (topicSummary) {
      const sm = topicSummary.closest('details') && topicSummary.closest('details').querySelector('summary');
      if (sm) sm.textContent = 'Topic';
    }

    // Vanilla / Coffee / Tea checkboxes above Topic (the section markup has no slot for them)
    if (!root.querySelector('[data-blog-facet="commodity"]') && topicSummary) {
      const topicBlock = topicSummary.closest('.blog-search__facet') || topicSummary.closest('details');
      if (topicBlock && topicBlock.parentNode) {
        const det = document.createElement('details');
        det.className = 'blog-search__facet blog-search__facet--commodity';
        det.open = true;
        det.innerHTML = '<summary>' + escapeHtml(COMMODITY_HEADING) + '</summary><div data-blog-facet="commodity"></div>';
        topicBlock.parentNode.insertBefore(det, topicBlock);
      }
    }

    // Read time: consistent dropdown styling + buckets that match real article lengths
    const rt = root.querySelector('[data-blog-read-time-filter]');
    if (rt) {
      rt.classList.add('blog-search__facet-select');
      rt.innerHTML =
        '<option value="">Any length</option>' +
        Object.keys(READ_TIME_LABELS).map(function (k) {
          return '<option value="' + escapeHtml(k) + '">' + escapeHtml(READ_TIME_LABELS[k]) + '</option>';
        }).join('');
      const block = rt.closest('.blog-search__facet');
      if (block) {
        block.classList.add('blog-search__facet--select');
        const lbl = block.querySelector('label');
        if (lbl) {
          lbl.classList.add('blog-search__facet-title');
          lbl.textContent = 'Read time';
          block.insertBefore(lbl, rt);
        }
      }
    }

    // Clear: small "Clear all" link next to the results count, never a big toolbar button
    const toolbarClear = root.querySelector('.blog-search__toolbar [data-blog-clear]');
    if (toolbarClear) toolbarClear.remove();
    const meta = root.querySelector('.blog-search__meta');
    if (meta && !meta.querySelector('[data-blog-clear]')) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'blog-search__clear';
      btn.setAttribute('data-blog-clear', '');
      btn.hidden = true;
      btn.textContent = 'Clear all';
      meta.appendChild(btn);
    }
    const results = root.querySelector('.blog-search__results-wrap');
    if (results && !root.querySelector('[data-blog-active]') && meta) {
      const act = document.createElement('div');
      act.className = 'blog-search__active';
      act.setAttribute('data-blog-active', '');
      act.hidden = true;
      meta.after(act);
    }
    const sort = root.querySelector('[data-blog-sort]');
    if (sort && sort.value !== FEATURED_SORT) sort.value = FEATURED_SORT;
  }

  function init(root) {
    const host = root.dataset.typesenseHost || '';
    const collection = root.dataset.typesenseCollection || '';
    const searchKey = root.dataset.typesenseSearchKey || '';
    const queryBy = root.dataset.queryBy || '';
    if (!host || !collection || !searchKey || !queryBy) {
      const summary = root.querySelector('[data-blog-summary]');
      if (summary) summary.textContent = 'Set host, collection, key, and query fields in section settings.';
      return;
    }

    root._blogSearchState = {
      config: {
        protocol: root.dataset.typesenseProtocol || 'https',
        host: host,
        port: root.dataset.typesensePort || '',
        path: root.dataset.typesensePath || '',
        collection: collection,
        searchKey: searchKey,
        queryBy: queryBy
      },
      perPage: Number(root.dataset.perPage || 12),
      query: '',
      sortBy: FEATURED_SORT,
      readTimeFilter: '',
      page: 1,
      totalPages: 1,
      selectedFacets: {}
    };

    upgradeLegacyMarkup(root);
    readUrl(root);

    const input = root.querySelector('[data-blog-search-input]');
    const sort = root.querySelector('[data-blog-sort]');
    const readTime = root.querySelector('[data-blog-read-time-filter]');
    const clear = root.querySelector('[data-blog-clear]');
    const prev = root.querySelector('[data-blog-prev]');
    const next = root.querySelector('[data-blog-next]');
    const toggle = root.querySelector('[data-blog-filters-toggle]');
    const filters = root.querySelector('.blog-search__filters');

    syncControls(root);
    if (sort) {
      sort.addEventListener('change', function () {
        root._blogSearchState.sortBy = sort.value || '';
        resetAndSearch(root);
      });
    }

    if (input) {
      input.addEventListener(
        'input',
        debounce(function () {
          root._blogSearchState.query = input.value || '';
          resetAndSearch(root);
        }, 220)
      );
    }

    if (readTime) {
      readTime.addEventListener('change', function () {
        root._blogSearchState.readTimeFilter = readTime.value || '';
        resetAndSearch(root);
      });
    }

    if (toggle && filters) {
      toggle.addEventListener('click', function () {
        const open = filters.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    if (clear) {
      clear.addEventListener('click', function () {
        const state = root._blogSearchState;
        state.query = '';
        state.sortBy = FEATURED_SORT;
        state.readTimeFilter = '';
        state.selectedFacets = {};
        if (input) input.value = '';
        if (sort) sort.value = FEATURED_SORT;
        if (readTime) readTime.value = '';
        resetAndSearch(root);
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        const state = root._blogSearchState;
        if (state.page <= 1) return;
        state.page -= 1;
        runSearch(root);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        const state = root._blogSearchState;
        if (state.page >= state.totalPages) return;
        state.page += 1;
        runSearch(root);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    bindFacetChange(root);
    setupTiles(root);
    runSearch(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-blog-search-root]').forEach(init);
  });
})();